import React from 'react';
import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';
import { SKELETON_ANIMATION, skeletonTintSx } from './skeletonTokens';

/**
 * Page-level dashboard placeholder: filters strip + metric cards + grid of cards.
 * Used by the shared page `LoadingSpinner` when `variant="dashboard"`.
 */
export const DashboardSectionSkeleton: React.FC = () => (
  <Box sx={{ p: 3 }} role="status">
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" animation={SKELETON_ANIMATION} width="60%" height={40} sx={skeletonTintSx} />
      <Skeleton variant="text" animation={SKELETON_ANIMATION} width="40%" height={24} sx={skeletonTintSx} />
    </Box>
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Skeleton variant="text" animation={SKELETON_ANIMATION} width="30%" height={32} sx={{ mb: 2, ...skeletonTintSx }} />
        <Grid container spacing={2}>
          {[1, 2, 3, 4].map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item}>
              <Skeleton variant="rounded" animation={SKELETON_ANIMATION} height={56} sx={skeletonTintSx} />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
    <Grid container spacing={3}>
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item}>
          <Card>
            <CardContent>
              <Skeleton variant="text" animation={SKELETON_ANIMATION} width="50%" height={24} sx={{ mb: 1, ...skeletonTintSx }} />
              <Skeleton variant="rounded" animation={SKELETON_ANIMATION} height={120} sx={{ mb: 1, ...skeletonTintSx }} />
              <Skeleton variant="text" animation={SKELETON_ANIMATION} width="30%" height={20} sx={skeletonTintSx} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
);
